// src/pages/LiveSupportPage.jsx
import React from 'react';
import PageHeader from './PageHeader';
import { useLanguage } from '../../context/LanguageContext';
import { FaHeadset, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';

const LiveSupportPage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "24x7 Live Support",
      title: "We're Here for You 24/7",
      subtitle: "Get instant help anytime with our dedicated support team.",
      contactMethods: "Contact Us Via",
      phone: "Phone: +91 744-8539858",
      email: "Email: Support@kalyanamatrimony.com",
      chat: "Live Chat: Available on website/app",
      hours: "Available 24 hours a day, 7 days a week",
      commitment: "Our friendly support team is always ready to assist you with profile issues, matching queries, privacy concerns, or any other questions. Your happiness and safety are our top priority!"
    },
    Tamil: {
      pageHeaderTitle: "24x7 நேரடி ஆதரவு",
      title: "நாங்கள் 24/7 உங்களுக்காக இருக்கிறோம்",
      subtitle: "எப்போது வேண்டுமானாலும் உடனடி உதவி பெறுங்கள்.",
      contactMethods: "எங்களை தொடர்பு கொள்ள",
      phone: "தொலைபேசி: +91 744-8539858",
      email: "மின்னஞ்சல்: Support@kalyanamatrimony.com",
      chat: "நேரடி அரட்டை: இணையதளம்/ஆப்-இல் கிடைக்கும்",
      hours: "வாரத்தில் 7 நாட்கள், 24 மணி நேரமும் கிடைக்கும்",
      commitment: "எங்கள் நட்பு ஆதரவு குழு சுயவிவர பிரச்சனைகள், இணைத்தல் கேள்விகள், தனியுரிமை கவலைகள் அல்லது வேறு ஏதேனும் கேள்விகளுக்கு எப்போதும் உதவ தயாராக உள்ளது. உங்கள் மகிழ்ச்சியும் பாதுகாப்பும் எங்கள் முதல் முன்னுரிமை!"
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader showBackButton={true} backTo="/" title={txt.pageHeaderTitle} />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <img src="https://www.praxedo.fr/wp-content/uploads/2021/06/Humanizing-customer-service-2.jpg" alt="24/7 Support Team" className="w-full h-96 object-cover rounded-2xl shadow-xl mb-10" />
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">{txt.title}</h1>
          <p className="text-xl text-gray-600">{txt.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
            <FaPhoneAlt className="text-5xl text-rose-600 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">{txt.contactMethods}</h3>
            <p className="text-lg text-gray-700">{txt.phone}</p>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
            <FaEnvelope className="text-5xl text-rose-600 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">{txt.contactMethods}</h3>
            <p className="text-lg text-gray-700">{txt.email}</p>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
            <FaHeadset className="text-5xl text-rose-600 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">{txt.contactMethods}</h3>
            <p className="text-lg text-gray-700">{txt.chat}</p>
          </div>
        </div>

        <div className="text-center mt-12 max-w-3xl mx-auto">
          <p className="text-lg text-gray-600 flex items-center justify-center gap-3"><FaClock className="text-rose-600" /> {txt.hours}</p>
          <p className="mt-8 text-xl text-gray-700 leading-relaxed">{txt.commitment}</p>
        </div>
      </div>
    </div>
  );
};

export default LiveSupportPage;